import { Suspense } from "react";

import { Box, Loader, Stack } from "@braintrust/braintrust-ui-components";
import type { OverwriteContentComponentProps } from "@js/layouts/app";

import { FreelancerDashboardWelcomeLazy } from "../../lazy";
import { FreelancerDashboardLayout } from "../layout";

import styles from "./styles.module.scss";

export const FreelancerDashboardWelcomePage = () => {
  return (
    <FreelancerDashboardLayout
      pageTitle="Welcome"
      pageColor="#EDE3FA"
      contentClassName={styles.content}
      OverwriteContentComponent={Wrapper}
    />
  );
};

const Wrapper = (props: OverwriteContentComponentProps) => {
  return (
    <Stack sx={{ flexGrow: 1 }}>
      <Box className={styles.nudge} />
      <Stack
        className={props.contentBoxProps.className}
        sx={{ p: { xs: "40px 16px", sm: "60px 30px", lg: "60px 4rem" } }}
      >
        <Suspense fallback={<Loader centered />}>
          <FreelancerDashboardWelcomeLazy />
        </Suspense>
      </Stack>
    </Stack>
  );
};
